import React, { useEffect, useState } from 'react';
import { Image } from '@hz-design-system/web-ui';
import { TMpCard } from 'types/TMpCard';
import { checkAndIncrementFrequencyCap } from './utils/frequencyCapping';
import { trackGAEvent } from '../../../../utils/gaTracking';

import Classes from './MpCard.scss';

type TMpCardProps = {
  mpCard: TMpCard;
  isLazy?: boolean;
};

const MpCard = ({ mpCard, isLazy = true }: TMpCardProps) => {
  const [shouldDisplay, setShouldDisplay] = useState(true);
  const { imageUrl, id } = mpCard;

  useEffect(() => {
    if (!mpCard) return;

    // Check frequency capping and increment view count
    const canDisplay = checkAndIncrementFrequencyCap(mpCard.id, mpCard.frequencyCap);
    setShouldDisplay(canDisplay);
  }, [mpCard]);

  if (!mpCard || !shouldDisplay) return null;

  const clickHandler = () => {
    if (mpCard.trackingEventName) {
      trackGAEvent(mpCard.trackingEventName, 'HPCards');
    }

    if (mpCard.landingUrl) {
      window.location.href = mpCard.landingUrl;
    }
  };

  return (
    <div
      className={`${Classes.mpCard} ${Classes.mpCard}--${id.toLowerCase()}`}
      onClick={clickHandler}
      onKeyDown={(e) => e.key === 'Enter' && clickHandler()}
      role="button"
      tabIndex={0}
    >
      <Image
        src={imageUrl}
        alt="Marketing Card. Click to place an ad"
        loading={isLazy ? 'lazy' : 'eager'}
        decoding={isLazy ? 'async' : 'sync'}
      />
    </div>
  );
};

export default React.memo(MpCard);
